import type { FC, ReactNode, CSSProperties } from 'react';
import classnames from 'classnames';

import plusIcon from 'app/icons/plus.svg';
import Button from 'app/components/Button/ResetedButton';
import Icon from 'app/components/Icon';

import style from './style.scss';

interface Props {
  children: ReactNode;
  onDelete: () => void;
  color?: 'blue' | 'orange';
  className?: string;
  style?: CSSProperties;
}

const colorClassNameMap = {
  blue: style.container_blue,
  orange: style.container_orange
};

const FilterTag: FC<Props> = ({ children, onDelete, color = 'blue', className, style: css }) => (
  <div className={classnames(style.container, colorClassNameMap[color], className)} style={css}>
    {children}
    <Button className={style.deleteButton} onClick={onDelete}>
      <Icon href={plusIcon} className={style.deleteIcon} />
    </Button>
  </div>
);

FilterTag.displayName = 'FilterTag';

export default FilterTag;
